module.exports = __webpack_public_path__ + "img/g.62640853.jpg";